import { render, staticRenderFns } from "./client-list.vue?vue&type=template&id=5ff0f824&"
import script from "./client-list.vue?vue&type=script&lang=ts&"
export * from "./client-list.vue?vue&type=script&lang=ts&"
import style0 from "./client-list.vue?vue&type=style&index=0&id=5ff0f824&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports